/* index.js */

"use strict";
const Steve = require("@gluenetworks/steve_core").getInstance();
const Registrations = require("./src/Registrations");

/**********************************************************************/
/* START STEVE PART Registrations                                     */
/**********************************************************************/

const LoginSection = require("./src/app/section/login/LoginSectionComponent");
Steve.di.registry.register(Registrations.LOGIN_CENTER_SECTION, LoginSection);

const LogoutSection = require("./src/app/section/logout/LogoutSectionComponent");
Steve.di.registry.register(Registrations.LOGOUT_CENTER_SECTION, LogoutSection);

const EulaSection = require("./src/app/section/eula/EulaSectionComponent");
Steve.di.registry.register(Registrations.EULA_SECTION, EulaSection);

const BannerSection = require("./src/app/section/banner/BannerSectionComponent");
Steve.di.registry.register(Registrations.BANNER_SECTION, BannerSection);

const FailsCommsSection = require("./src/app/section/failcomms/DefaultFailCommsSectionMgrComponent");
Steve.di.registry.register(Registrations.FAIL_COMMS_SECTION, FailsCommsSection);

const PasswordResetSection = require("./src/app/section/passwordreset/PasswordResetSectionComponent");
Steve.di.registry.register(Registrations.PASSWORD_RESET_SECTION, PasswordResetSection);

const SolutionSwitcherSection = require("./src/app/section/solutionSwitcher/SolutionSwitcherSectionComponent");
Steve.di.registry.register(Registrations.SOLUTION_SWITCHER_SECTION, SolutionSwitcherSection);
Steve.di.registry.register("App.GameConsole.Section.Landing", SolutionSwitcherSection);

/**********************************************************************/
/* END STEVE PART Registrations                                       */
/**********************************************************************/

module.exports = {
    LoginSection,
    EulaSection,
    FailsCommsSection,
    PasswordResetSection,
    SolutionSwitcherSection,
    ServiceAddon: require("./src/libs/tempAddon/ServiceAddon"),
};
